import React from "react";
import { Breadcrumb } from "../components/shared/Breadcrumb";
import { ButtonLink } from "../components/shared/Button";
import { BuildingJourney } from "../components/sections/BuildingJourney";
import { PageMeta } from "../components/shared/PageMeta";
export function OurProcess() {
  return <>
      <PageMeta title="Our Building Process | Oceanside Living Perth" description="How building with Oceanside Living works, from your first conversation and pre-construction agreement to construction and handover." data-id="element-790" data-mp="1c7qspt13phih" />
      <div className="mx-auto max-w-site px-5 pb-16 pt-10 md:px-10 md:pb-28 md:pt-14" data-id="element-791" data-mp="1l6cavn2nuuiq">
        <Breadcrumb items={[{
        label: "Home",
        to: "/"
      }, {
        label: "Our process"
      }]} data-id="element-792" data-mp="1q7rt77dgemxf" />
        <div className="mt-6 grid gap-8 lg:grid-cols-12" data-id="element-793" data-mp="1v50evhxt993f">
          <div className="lg:col-span-7" data-id="element-794" data-mp="3ryv5s26wmbkm">
            <h1 className="text-[38px] font-semibold leading-[1.08] tracking-tight md:text-[60px]" data-id="element-795" data-mp="3rzwsj3xa8mi6">Our building process</h1>
            <p className="mt-5 text-[17px] leading-relaxed text-slate md:text-lg" data-id="element-796" data-mp="uelr9a1ois3">
              Building a home is a big decision. Whether you choose one of our designs and make it your own, or take the custom
              design route, we guide you through six clear stages so you know what’s happening, what’s required and what’s coming next.
            </p>
          </div>
          <aside className="rounded-[24px] border-l-4 border-ocean bg-white p-6 lg:col-span-5 lg:self-end" data-id="element-797" data-mp="2ribs2txbf06y">
            <h2 className="text-lg font-semibold" data-id="element-798" data-mp="3o6ries891dl4">How long does it take?</h2>
            <p className="mt-2 text-[16px] leading-relaxed text-slate" data-id="element-799" data-mp="3j99hnp4dy4o7">
              Allow around 20 to 25 weeks for pre-construction (finance, selections, plans and the building permit), then around
              9 to 10 months on site for a single-storey home. We keep you updated at every stage.
            </p>
          </aside>
        </div>
        <div className="mt-14" data-id="element-800" data-mp="23p3bp0sliwdo">
          <BuildingJourney detailed data-id="element-801" data-mp="1yrtlhixdugos" />
        </div>
        <div className="mt-14 flex flex-col gap-4 sm:flex-row" data-id="element-802" data-mp="1yufvdp7qx8a6">
          <ButtonLink to="/contact" data-id="element-803" data-mp="20ajxsvau6a90">Book a consultation</ButtonLink>
          <ButtonLink to="/#faqs" variant="secondary" data-id="element-804" data-mp="258d0hecxkm4j">Read common questions</ButtonLink>
        </div>
      </div>
    </>;
}